<div class="estimator-page">
  <header class="mobile-estimator-header">
    <div class="mobile-brand-block">
      <div class="mobile-logo">Fr</div>
      <div>
        <span>FRANTINCO</span>
        <h1>Estimator</h1>
      </div>
    </div>
    <button type="button" class="mobile-back-btn" (click)="openReturnToVisualizerConfirm()">
      <mat-icon aria-hidden="true">arrow_back</mat-icon>
      Visualizer
    </button>
  </header>

  <div class="estimator-layout">
    <section class="product-panel">
      <div class="product-panel-header">
        <h2>Produk</h2>
        <p>Pilih produk manual kalau tidak dilempar dari visualizer.</p>
        <input type="text" [(ngModel)]="search" placeholder="Cari produk..." class="search-input" />
      </div>

      <div class="product-list">
        <button type="button" class="product-card" *ngFor="let product of filteredProducts" (click)="addManualProduct(product)">
          <img [src]="getProductImage(product)" [alt]="product.name || product.code" />
          <div class="product-info">
            <strong>{{ product.name || product.product_name || product.code }}</strong>
            <span>{{ product.code || product.sku }}</span>
            <small>{{ getProductCategory(product) }}</small>
          </div>
        </button>
      </div>
    </section>

    <section class="estimator-panel">
      <div class="title-row">
        <div>
          <span>FRANTINCO</span>
          <h1>Estimator</h1>
        </div>
        <div class="title-actions">
          <strong *ngIf="totalQuantity > 0">{{ totalQuantity }} total</strong>
          <button type="button" class="title-back-btn" aria-label="Kembali ke visualizer" (click)="openReturnToVisualizerConfirm()">
            <mat-icon aria-hidden="true">arrow_back</mat-icon>
            <span>Visualizer</span>
          </button>
        </div>
      </div>

      <div class="visualizer-image-card" *ngIf="generatedImageUrl">
        <div class="card-title-row">
          <div>
          <h3>Gambar Hasil Visualizer</h3>
          <p>Gambar hasil visualisasi dari visualizer.</p>
          </div>
          <div class="visualizer-image-actions">
            <button type="button" class="small-btn visualizer-toggle-btn" (click)="toggleVisualizerImage()" [disabled]="!originalImageUrl">
              {{ visualizerImageToggleLabel }}
            </button>
            <button
              type="button"
              class="small-btn icon-btn"
              title="Download gambar"
              aria-label="Download gambar preview"
              (click)="downloadVisualizerPreview()"
              [disabled]="!displayedVisualizerImageUrl"
            >
              <mat-icon aria-hidden="true">file_download</mat-icon>
            </button>
          </div>
        </div>
        <img [src]="displayedVisualizerImageUrl" alt="Hasil visualizer" />

      </div>

      <ng-template #roomSizeOverviewTemplate>
      <div class="room-size-overview">
        <div class="room-size-overview-header">
          <div>
            <span>Ukuran Ruangan</span>
            <strong>{{ roomTotalArea | number:'1.0-2' }} m²</strong>
          </div>
          <button type="button" class="room-sync-size-btn" (click)="syncEstimatorWithRoomSize()" [disabled]="roomSizeSynced">
            <mat-icon aria-hidden="true">sync</mat-icon>
            <span>Sinkron Box</span>
          </button>
        </div>

        <div class="room-dimension-grid">
          <label>
            <span>Panjang</span>
            <input
              type="text"
              inputmode="decimal"
              [value]="formatRoomDimensionInput(roomManualLength)"
              (input)="onRoomManualDimensionInput('length', $event)"
            />
          </label>
          <label>
            <span>Lebar</span>
            <input
              type="text"
              inputmode="decimal"
              [value]="formatRoomDimensionInput(roomManualWidth)"
              (input)="onRoomManualDimensionInput('width', $event)"
            />
          </label>
          <label>
            <span>Tinggi</span>
            <input
              type="text"
              inputmode="decimal"
              [value]="formatRoomDimensionInput(roomManualHeight)"
              (input)="onRoomManualDimensionInput('height', $event)"
            />
          </label>
        </div>

        <div class="room-area-grid">
          <div>
            <span>Luas Lantai</span>
            <strong *ngIf="roomManualArea > 0; else desktopFloorHint">{{ roomManualArea | number:'1.0-2' }} m²</strong>
            <ng-template #desktopFloorHint><small>{{ roomFloorCeilingHint }}</small></ng-template>
          </div>
          <div>
            <span>Luas Ceiling</span>
            <strong *ngIf="roomManualArea > 0; else desktopCeilingHint">{{ roomManualArea | number:'1.0-2' }} m²</strong>
            <ng-template #desktopCeilingHint><small>{{ roomFloorCeilingHint }}</small></ng-template>
          </div>
          <div>
            <span>Luas Dinding</span>
            <strong *ngIf="roomManualWallArea > 0; else desktopWallHint">{{ roomManualWallArea | number:'1.0-2' }} m²</strong>
            <ng-template #desktopWallHint><small>{{ roomWallHint }}</small></ng-template>
          </div>
        </div>
      </div>
      </ng-template>

      <div class="source-alert" *ngIf="sourceFromVisualizer">
        Produk dikirim dari Visualizer. Sesuaikan ukuran ruangan dan area produk jika diperlukan.
      </div>

      <div class="estimator-side-actions estimator-side-actions-landscape">
        <ng-container *ngTemplateOutlet="roomSizeOverviewTemplate"></ng-container>

        <div class="grand-total-card">
          <div class="grand-total-row">
            <span>Total Jumlah Produk</span>
            <strong>{{ totalSurfaceCount }}</strong>
          </div>
          <div class="grand-total-row">
            <span>Estimasi Total Box/Sheet</span>
            <strong class="requirement-summary">{{ totalRequirementSummary }}</strong>
          </div>
        </div>

        <div class="estimator-contact-actions">
          <a class="contact-btn whatsapp" [href]="whatsappLink" target="_blank" rel="noopener">
            <mat-icon aria-hidden="true">chat</mat-icon>
            <span>WhatsApp</span>
          </a>
        </div>
      </div>

      <div class="empty-state" *ngIf="estimatorItems.length === 0">
        Belum ada produk estimasi. Pilih produk dari panel kiri atau kirim dari visualizer.
      </div>

      <div class="estimate-item" *ngFor="let item of estimatorItems; let index = index">
        <button type="button" class="estimate-summary" (click)="toggleItem(item)">
          <div class="summary-left">
            <img [src]="getProductImage(item.product)" [alt]="item.product.name || item.product.code" />
            <div>
              <small>{{ item.surfaceLabel }}</small>
              <strong>{{ item.product.name }}</strong>
              <span>{{ item.product.code || item.product.sku }}</span>
            </div>
          </div>

          <div class="summary-right">
            <b *ngIf="item.result">{{ item.result.requiredQty }} {{ item.result.coverageType }}</b>
            <b class="summary-size-label" *ngIf="!item.result && !item.expanded">Isi ukuran</b>
            <mat-icon aria-hidden="true">{{ item.expanded ? 'remove' : 'add' }}</mat-icon>
          </div>
        </button>

        <div class="estimate-body" *ngIf="item.expanded">
          <div class="ai-size-card">
            <div>
              <span>Ukuran dari AI / Python</span>
              <strong *ngIf="hasAiSize(item)">
                <ng-container *ngIf="item.aiLength > 0 && item.aiWidth > 0; else areaOnly">
                  {{ item.aiLength | number:'1.0-2' }}m x {{ item.aiWidth | number:'1.0-2' }}m =
                  {{ getActiveArea(item) | number:'1.0-2' }} m²
                </ng-container>
                <ng-template #areaOnly>{{ item.aiAreaM2 | number:'1.0-2' }} m²</ng-template>
              </strong>
              <strong *ngIf="!hasAiSize(item)">Belum ada ukuran AI. Pakai ukuran manual.</strong>
            </div>

            <label class="manual-check">
              <input type="checkbox" [(ngModel)]="item.useManualSize" (ngModelChange)="onManualToggle(item)" />
              <span>Isi ukuran manual</span>
            </label>
          </div>

          <div class="input-grid" *ngIf="item.useManualSize">
            <label>
              <span>Panjang</span>
              <input type="text" inputmode="decimal" [value]="formatEstimatorDimensionInput(item.manualLength)" (input)="onEstimatorDimensionInput(item, 'length', $event)" />
              <small>meter</small>
            </label>
            <label>
              <span>Lebar</span>
              <input type="text" inputmode="decimal" [value]="formatEstimatorDimensionInput(item.manualWidth)" (input)="onEstimatorDimensionInput(item, 'width', $event)" />
              <small>meter</small>
            </label>
            <label class="span-2">
              <span>Area langsung</span>
              <input type="text" inputmode="decimal" [value]="formatEstimatorDimensionInput(item.manualAreaM2)" (input)="onEstimatorDimensionInput(item, 'area', $event)" />
              <small>m², opsional jika panjang/lebar tidak ada</small>
            </label>
          </div>

          <div class="details-card" *ngIf="item.result">
            <h3>Detail</h3>
            <div class="detail-row"><span>Kategori</span><strong>: {{ getProductCategory(item.product) }}</strong></div>
            <div class="detail-row"><span>Seri</span><strong>: {{ getProductSeries(item.product) }}</strong></div>
            <div class="detail-row"><span>Ukuran</span><strong>: {{ getProductSize(item.product) }}</strong></div>
            <div class="detail-row"><span>Luas Area</span><strong>: {{ item.result.roomSize | number:'1.0-2' }} m²</strong></div>
            <div class="detail-row"><span>Cakupan</span><strong>: {{ getCoverageText(item.product) }}</strong></div>
            <div class="detail-row"><span>Cadangan Potongan</span><strong>: {{ getWasteText(item.product) }}</strong></div>
          </div>

          <div class="result-card" *ngIf="item.result">
            <p>Estimasi jumlah kebutuhan</p>
            <h2>{{ item.result.requiredQty }} {{ item.result.coverageType }}</h2>
            <div class="formula">Luas Area = {{ item.result.roomSize | number:'1.0-2' }} m²</div>
            <div class="formula">
              {{ item.result.multiplier | number:'1.2-2' }} x
              ({{ item.result.roomSize | number:'1.0-2' }} m² / {{ item.result.coverage }} m²)
              = {{ item.result.requiredRaw | number:'1.2-2' }} =
              {{ item.result.requiredQty }} {{ item.result.coverageType }}
            </div>
          </div>

          <button type="button" class="remove-btn" (click)="removeItem(index)">Hapus Produk</button>
        </div>
      </div>

      <div class="estimator-side-actions estimator-side-actions-default">
        <ng-container *ngTemplateOutlet="roomSizeOverviewTemplate"></ng-container>

        <div class="grand-total-card">
          <div class="grand-total-row">
            <span>Total Jumlah Produk</span>
            <strong>{{ totalSurfaceCount }}</strong>
          </div>
          <div class="grand-total-row">
            <span>Estimasi Total Box/Sheet</span>
            <strong class="requirement-summary">{{ totalRequirementSummary }}</strong>
          </div>
        </div>

        <div class="estimator-contact-actions">
          <a class="contact-btn whatsapp" [href]="whatsappLink" target="_blank" rel="noopener">
            <mat-icon aria-hidden="true">chat</mat-icon>
            <span>WhatsApp</span>
          </a>
        </div>
      </div>

      <a class="whatsapp-btn" *ngIf="totalQuantity > 0" [href]="whatsappLink" target="_blank" rel="noopener">
        Konsultasi via WhatsApp
      </a>

      <section class="mobile-action-panel mobile-products-panel" *ngIf="mobileActivePanel === 'products'">
        <div class="mobile-sheet-handle" aria-hidden="true"></div>
        <div class="mobile-products-header">
          <nav class="mobile-breadcrumb" aria-label="Breadcrumb">
            <button type="button" class="breadcrumb-home" (click)="backToMobileProductCategories()" aria-label="Beranda produk">
              <mat-icon aria-hidden="true">home</mat-icon>
            </button>
            <span class="breadcrumb-title">{{ mobileProductPanelTitle }}</span>
          </nav>
          <button type="button" class="mobile-panel-close" (click)="setMobilePanel(null)" aria-label="Tutup panel produk">
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        </div>

        <div class="mobile-search-row">
          <label class="mobile-search-field">
            <mat-icon aria-hidden="true">search</mat-icon>
            <input type="text" [(ngModel)]="search" placeholder="Cari produk..." />
          </label>
          <button type="button" class="mobile-view-btn" aria-label="Filter produk">
            <mat-icon aria-hidden="true">tune</mat-icon>
          </button>
        </div>

        <div class="mobile-series-carousel" *ngIf="mobileProductStep === 'category'" aria-label="Pilihan kategori produk">
          <button
            type="button"
            class="mobile-series-card"
            *ngFor="let category of mobileCategoryCards"
            [class.selected]="selectedMobileCategoryKey === category.key"
            (click)="selectMobileCategory(category.key)"
          >
            <div class="mobile-series-thumb" [class.all-series]="category.key === 'all'">
              <img *ngIf="category.image" [src]="category.image" [alt]="category.name" />
              <mat-icon *ngIf="!category.image" aria-hidden="true">category</mat-icon>
            </div>
            <strong>{{ category.key === 'all' ? 'Kategori' : category.name }}</strong>
            <small>{{ category.count }} produk</small>
          </button>
        </div>

        <div class="mobile-series-carousel" *ngIf="mobileProductStep === 'series'" aria-label="Pilihan series produk">
          <button type="button" class="mobile-series-card mobile-back-card" (click)="backToMobileProductCategories()">
            <div class="mobile-series-thumb all-series">
              <mat-icon aria-hidden="true">arrow_back</mat-icon>
            </div>
            <strong>Kategori</strong>
            <small>Kembali</small>
          </button>

          <button
            type="button"
            class="mobile-series-card"
            *ngFor="let series of mobileSeriesCards"
            [class.selected]="selectedMobileSeriesKey === series.key"
            (click)="selectMobileSeries(series.key)"
          >
            <div class="mobile-series-thumb" [class.all-series]="series.key === 'all'">
              <img *ngIf="series.image" [src]="series.image" [alt]="series.name" />
              <mat-icon *ngIf="!series.image" aria-hidden="true">category</mat-icon>
            </div>
            <strong>{{ series.name }}</strong>
            <small>{{ series.count }} produk</small>
          </button>
        </div>

        <div class="mobile-series-carousel" *ngIf="mobileProductStep === 'product'" aria-label="Pilihan produk">
          <button type="button" class="mobile-series-card mobile-back-card" (click)="backToMobileProductSeries()">
            <div class="mobile-series-thumb all-series">
              <mat-icon aria-hidden="true">arrow_back</mat-icon>
            </div>
            <strong>Seri</strong>
            <small>Kembali</small>
          </button>

          <button
            type="button"
            class="mobile-product-choice"
            *ngFor="let product of mobileProductsForSelectedSeries"
            (click)="addManualProduct(product)"
          >
            <span class="mobile-product-thumb">
              <img [src]="getProductImage(product)" [alt]="product.name || product.product_name || product.code" />
              <mat-icon class="mobile-add-indicator" aria-hidden="true">add</mat-icon>
            </span>
            <strong>{{ product.code || product.sku }}</strong>
            <span class="mobile-product-name">{{ product.name || product.product_name || product.code }}</span>
          </button>
        </div>

        <p class="mobile-products-empty" *ngIf="mobileProductStep === 'series' && mobileSeriesCards.length === 0">
          Seri tidak ditemukan.
        </p>

        <p class="mobile-products-empty" *ngIf="mobileProductStep === 'product' && mobileProductsForSelectedSeries.length === 0">
          Produk tidak ditemukan.
        </p>
      </section>

      <section class="mobile-action-panel mobile-cart-panel" *ngIf="mobileActivePanel === 'cart'">
        <div class="mobile-sheet-handle" aria-hidden="true"></div>
        <button type="button" class="mobile-panel-close" (click)="setMobilePanel(null)" aria-label="Tutup keranjang">
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
        <h2>Keranjang</h2>

        <div class="mobile-cart-section" *ngFor="let group of mobileSurfaceGroups">
          <div class="mobile-surface-heading">
            <strong>{{ group.label | uppercase }}</strong>
            <span>{{ group.area | number:'1.0-0' }} m²</span>
          </div>

          <article class="mobile-cart-item" *ngFor="let item of getSurfaceGroupProductItems(group)">
            <div class="mobile-cart-row">
              <div class="mobile-cart-thumb-wrap">
                <img [src]="getProductImage(item.product)" [alt]="item.product.name || item.product.code" />
                <span>{{ getSurfaceBadgeLabel(item) }}</span>
              </div>
              <div class="mobile-cart-copy">
                <strong>{{ item.product.name || item.product.product_name || item.product.code }}</strong>
                <small>{{ getProductCategory(item.product) }}</small>
              </div>
              <div class="mobile-box-control" aria-label="Jumlah box">
                <button type="button" (click)="decrementCartBox(item)" aria-label="Kurangi box">
                  <mat-icon aria-hidden="true">remove</mat-icon>
                </button>
                <strong>{{ getCartBoxQty(item) }}</strong>
                <span>box</span>
                <button type="button" (click)="incrementCartBox(item)" aria-label="Tambah box">
                  <mat-icon aria-hidden="true">add</mat-icon>
                </button>
              </div>
              <button type="button" class="mobile-more-btn" (click)="toggleCartItemMenu(item)" aria-label="Menu produk">
                <mat-icon aria-hidden="true">more_vert</mat-icon>
              </button>
            </div>
            <div class="mobile-cart-item-menu" *ngIf="openCartMenuItemId === item.id">
              <button type="button" (click)="changeCartItemProduct(item)">
                <mat-icon aria-hidden="true">swap_horiz</mat-icon>
                <span>Ganti Produk</span>
              </button>
              <button type="button" class="danger" (click)="removeCartItem(item)">
                <mat-icon aria-hidden="true">delete</mat-icon>
                <span>Hapus Produk</span>
              </button>
            </div>
            <div class="mobile-product-area">
              <span>Luas Produk</span>
              <label class="mobile-product-area-input">
                <input
                  type="text"
                  inputmode="decimal"
                  [value]="getCartAreaInputValue(item)"
                  (input)="onCartItemAreaInput(item, $event)"
                />
                <small>m²</small>
              </label>
              <strong>{{ getMobileItemArea(item) | number:'1.0-0' }} m²</strong>
            </div>
          </article>
        </div>

        <div class="mobile-cart-summary">
          <div>
            <span>Total Item</span>
            <strong>{{ totalSurfaceCount }} Area</strong>
          </div>
          <div>
            <span>Total Estimasi</span>
            <strong>{{ totalEstimateArea | number:'1.0-0' }} m²</strong>
          </div>
        </div>
      </section>

      <section class="mobile-action-panel mobile-detail-panel" *ngIf="mobileActivePanel === 'detail'">
        <button type="button" class="mobile-panel-close" (click)="setMobilePanel(null)" aria-label="Tutup detail estimasi">
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
        <h2>Detail Estimasi</h2>

        <div class="mobile-estimate-summary">
          <h3>RINGKASAN ESTIMASI</h3>
          <div class="mobile-summary-grid">
            <div>
              <mat-icon aria-hidden="true">select_all</mat-icon>
              <small>Total Area</small>
              <strong>{{ totalSurfaceCount }} Area</strong>
            </div>
            <div>
              <mat-icon aria-hidden="true">crop_square</mat-icon>
              <small>Total Luas</small>
              <strong>{{ totalEstimateArea | number:'1.0-0' }} m²</strong>
            </div>
            <div>
              <mat-icon aria-hidden="true">calculate</mat-icon>
              <small>Total Estimasi</small>
              <strong>{{ totalEstimateArea | number:'1.0-0' }} m²</strong>
            </div>
          </div>
        </div>

        <div class="mobile-room-size-list">
          <article class="mobile-room-size-card">
            <div class="mobile-room-size-header">
              <span>Luas Ruangan</span>
              <strong>{{ roomTotalArea | number:'1.0-2' }} m²</strong>
            </div>

            <div class="mobile-room-size-grid">
              <label>
                <span>Panjang</span>
                <input
                  type="text"
                  inputmode="decimal"
                  [value]="formatRoomDimensionInput(roomManualLength)"
                  (input)="onRoomManualDimensionInput('length', $event)"
                />
              </label>
              <label>
                <span>Lebar</span>
                <input
                  type="text"
                  inputmode="decimal"
                  [value]="formatRoomDimensionInput(roomManualWidth)"
                  (input)="onRoomManualDimensionInput('width', $event)"
                />
              </label>
              <label>
                <span>Tinggi</span>
                <input
                  type="text"
                  inputmode="decimal"
                  [value]="formatRoomDimensionInput(roomManualHeight)"
                  (input)="onRoomManualDimensionInput('height', $event)"
                />
              </label>
            </div>

            <div class="mobile-room-area-breakdown">
              <div>
                <span>Lantai</span>
                <strong *ngIf="roomManualArea > 0; else floorHint">{{ roomManualArea | number:'1.0-2' }} m²</strong>
                <ng-template #floorHint><small>{{ roomFloorCeilingHint }}</small></ng-template>
              </div>
              <div>
                <span>Ceiling</span>
                <strong *ngIf="roomManualArea > 0; else ceilingHint">{{ roomManualArea | number:'1.0-2' }} m²</strong>
                <ng-template #ceilingHint><small>{{ roomFloorCeilingHint }}</small></ng-template>
              </div>
              <div>
                <span>Dinding</span>
                <strong *ngIf="roomManualWallArea > 0; else wallHint">{{ roomManualWallArea | number:'1.0-2' }} m²</strong>
                <ng-template #wallHint><small>{{ roomWallHint }}</small></ng-template>
              </div>
            </div>
          </article>
        </div>

        <div class="mobile-section-title-row">
          <h3 class="mobile-section-title">PRODUK YANG DIGUNAKAN</h3>
          <button type="button" class="mobile-sync-size-btn" (click)="syncEstimatorWithRoomSize()" [disabled]="roomSizeSynced">
            <mat-icon aria-hidden="true">sync</mat-icon>
            <span>Sinkron Box</span>
          </button>
        </div>
        <div class="mobile-used-products mobile-used-products-portrait">
          <article
            class="mobile-used-estimate-card"
            [class.mobile-used-estimate-card-multi]="hasMultiProductSurfaceGroup(group)"
            *ngFor="let group of mobileSurfaceGroups"
          >
            <ng-container *ngIf="hasMultiProductSurfaceGroup(group); else singleSurfaceCard">
              <div class="mobile-surface-product-stack">
                <div class="mobile-surface-product-row" *ngFor="let productItem of getSurfaceGroupProductItems(group)">
                  <div class="mobile-used-thumb-wrap mobile-surface-product-thumb">
                    <img [src]="getProductImage(productItem.product)" [alt]="getSurfaceGroupProductName(productItem)" />
                    <span>{{ group.label }}</span>
                  </div>

                  <div class="mobile-used-main-copy mobile-surface-product-copy">
                    <strong>{{ getSurfaceGroupProductName(productItem) }}</strong>
                    <div class="mobile-product-meta-row">
                      <em>{{ getProductCategory(productItem.product) }}</em>
                      <span
                        class="mobile-waste-tooltip"
                        *ngIf="hasWaste(productItem.product)"
                        [attr.title]="getWasteTooltip(productItem.product)"
                        [attr.aria-label]="getWasteTooltip(productItem.product)"
                      >
                        <mat-icon aria-hidden="true">info</mat-icon>
                        Waste {{ getWasteText(productItem.product) }}
                      </span>
                    </div>
                    <p>{{ getProductDescription(productItem.product) }}</p>
                  </div>

                  <div class="mobile-surface-product-box">
                    <span>Estimasi Box</span>
                    <ng-container *ngIf="isSurfaceProductBoxAdjustmentNeeded(productItem); else adjustedSurfaceProductBox">
                      <em>Perlu di adjust</em>
                    </ng-container>
                    <ng-template #adjustedSurfaceProductBox>
                      <strong>{{ getSurfaceProductBoxQty(productItem) }} <small>box</small></strong>
                    </ng-template>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-template #singleSurfaceCard>
              <div class="mobile-used-thumb-wrap">
                <img [src]="getProductImage(getSurfaceGroupPrimaryItem(group).product)" [alt]="getSurfaceGroupTitle(group)" />
                <span>{{ group.label }}</span>
              </div>

              <div class="mobile-used-main-copy">
                <strong>{{ getSurfaceGroupTitle(group) }}</strong>
                <div class="mobile-product-meta-row">
                  <em>{{ getSurfaceGroupCategory(group) }}</em>
                  <span
                    class="mobile-waste-tooltip"
                    *ngIf="hasWaste(getSurfaceGroupPrimaryItem(group).product)"
                    [attr.title]="getWasteTooltip(getSurfaceGroupPrimaryItem(group).product)"
                    [attr.aria-label]="getWasteTooltip(getSurfaceGroupPrimaryItem(group).product)"
                  >
                    <mat-icon aria-hidden="true">info</mat-icon>
                    Waste {{ getWasteText(getSurfaceGroupPrimaryItem(group).product) }}
                  </span>
                </div>
                <p>{{ getSurfaceGroupDescription(group) }}</p>
              </div>
            </ng-template>

            <div
              class="mobile-used-estimate-metrics"
              [class.mobile-used-estimate-metrics-multi]="hasMultiProductSurfaceGroup(group)"
            >
              <ng-container *ngIf="!hasMultiProductSurfaceGroup(group)">
              <div>
                <span>Luas</span>
                <strong>{{ getMobileItemArea(item) | number:'1.0-0' }} <small>m²</small></strong>
              </div>
              <div>
                <span>Estimasi Box</span>
                <strong class="mobile-adjust-warning" *ngIf="hasMultiProductSurfaceGroup(group); else singleSurfaceBox">
                  Perlu di adjust
                </strong>
                <ng-template #singleSurfaceBox>
                  <strong>{{ getSurfaceGroupBoxQty(group) }} <small>box</small></strong>
                </ng-template>
              </div>
              </ng-container>
              <button
                type="button"
                (click)="openSurfaceGroupAdjust(group)"
                [attr.aria-label]="hasMultiProductSurfaceGroup(group) ? 'Buka keranjang untuk atur luas produk' : 'Ubah di keranjang'"
              >
                <mat-icon aria-hidden="true">edit</mat-icon>
                <span>{{ hasMultiProductSurfaceGroup(group) ? 'Buka' : 'Ubah' }}</span>
              </button>
            </div>
          </article>
        </div>

        <div class="mobile-used-products mobile-used-products-compact">
          <article class="mobile-used-item" *ngFor="let item of estimatorItems">
            <img [src]="getProductImage(item.product)" [alt]="item.product.name || item.product.code" />
            <div class="mobile-used-copy">
              <small>{{ item.surfaceLabel | uppercase }}</small>
              <strong>{{ item.product.name || item.product.product_name || item.product.code }}</strong>
              <span>{{ item.product.code || item.product.sku }}</span>
              <em>{{ getProductCategory(item.product) }}</em>
            </div>
            <div class="mobile-used-measure">
              <span>Luas</span>
              <strong>{{ getMobileItemArea(item) | number:'1.0-0' }} m²</strong>
              <small>({{ getCartBoxQty(item) }} box)</small>
            </div>
            <div class="mobile-used-measure">
              <span>Estimasi</span>
              <strong>{{ getMobileItemArea(item) | number:'1.0-0' }} m²</strong>
            </div>
            <mat-icon class="mobile-chevron" aria-hidden="true">chevron_right</mat-icon>
          </article>
        </div>

        <p class="mobile-estimate-note">
          Estimasi ini bersifat sementara berdasarkan ukuran dari Visualizer. Silakan sesuaikan ukuran secara manual jika diperlukan.
        </p>
      </section>
    </section>
  </div>

  <nav class="mobile-estimator-bottom-bar" aria-label="Aksi estimator mobile">
    <button type="button" [class.active]="mobileActivePanel === 'products'" (click)="setMobilePanel('products')">
      <mat-icon aria-hidden="true">view_list</mat-icon>
      <strong>Daftar Produk</strong>
    </button>
    <button type="button" [class.active]="mobileActivePanel === 'cart'" (click)="setMobilePanel('cart')">
      <mat-icon class="mobile-cart-icon" aria-hidden="true">shopping_cart</mat-icon>
      <i *ngIf="totalSurfaceCount > 0">{{ totalSurfaceCount }}</i>
      <strong>Keranjang</strong>
    </button>
    <a class="mobile-whatsapp-action" [href]="whatsappLink" target="_blank" rel="noopener">
      <mat-icon aria-hidden="true">chat</mat-icon>
      <strong>Kirim ke WhatsApp</strong>
    </a>
    <button type="button" [class.active]="mobileActivePanel === 'detail'" (click)="setMobilePanel('detail')">
      <mat-icon aria-hidden="true">description</mat-icon>
      <strong>Detail Estimasi</strong>
    </button>
  </nav>

  <div class="return-confirm-backdrop" *ngIf="returnConfirmOpen" role="presentation" (click)="closeReturnToVisualizerConfirm()">
    <section class="return-confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="return-confirm-title" (click)="$event.stopPropagation()">
      <button type="button" class="return-confirm-close" aria-label="Tutup" (click)="closeReturnToVisualizerConfirm()">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>

      <h2 id="return-confirm-title">Kembali ke Visualizer?</h2>
      <p>
        Produk manual akan dihapus. Produk yang punya hotspot surface akan dikirim kembali ke Visualizer sesuai area sebelumnya.
      </p>
      <small>{{ visualizerReturnItemCount }} produk surface akan dibawa kembali.</small>

      <div class="return-confirm-actions">
        <button type="button" class="return-confirm-secondary" (click)="closeReturnToVisualizerConfirm()">Batal</button>
        <button type="button" class="return-confirm-primary" (click)="confirmReturnToVisualizer()">
          Kembali ke Visualizer
        </button>
      </div>
    </section>
  </div>
</div>
